<template>
    <div>
        <div class="bg-gray2">
            <div class="container-fluid">
                <!--/* Capsule offre */-->
                <selected-offer
                    v-if="selectedOffer"
                    class="mt-2 mb-1 d-webview-none"
                    :title="selectedOffer.title"
                    :continue-without-mobile="selectedOffer.continueWithoutMobile"
                    :modify-mobile-label="selectedOffer.modifyMobileLabel"
                    :modify-offer="selectedOffer.modifyOffer"
                    :offer-label="selectedOffer.offerLabel"
                />

                <!--/* lien retour */-->
                <div class="py-1">
                    <ob1-liens
                        :href="'#'"
                        :text="mobileDetails.back.label"
                        :is-back="true"
                        :with-arrow="true"
                        @ob1-liens-click="handleBackLink"
                    />
                </div>
                <!--/* affichage du rappel contrat client */-->
                <contract-phone-lines
                    v-if="mobileDetails.contractInfos"
                    class="mb-md-1 my-lg-1"
                    :contract-infos="mobileDetails.contractInfos"
                />
                <incentive
                    v-if="mobileDetails.incentiveDto"
                    :title="mobileDetails.incentiveDto.question"
                    :text="mobileDetails.incentiveDto.message"
                    :link-href="mobileDetails.currentVersion.advantagesLabels.href"
                    :link-label="mobileDetails.incentiveDto.linkLabel"
                />
                <intention-switch
                    v-if="mobileDetails.intentionSwitchDto"
                    class="pb-1"
                    :shop-sosh="isSoshShop"
                    :title="mobileDetails.intentionSwitchDto.title"
                    :inline-alert="mobileDetails.pcmoaInfoMessage"
                    :acquisition-label="mobileDetails.intentionSwitchDto.acquisitionLabel"
                    :tseul-label="mobileDetails.intentionSwitchDto.tseulLabel"
                    :renewal-label="mobileDetails.intentionSwitchDto.renewalLabel"
                    :changer-de-mobile-label="mobileDetails.intentionSwitchDto.changerDeMobileLabel"
                    :default-intention-checked="intentionParam"
                    @switch-intention="switchIntention($event)"
                />
                <!--/* Popin authent */-->
                <template v-if="currentVersion.customerPopinDto">
                    <customer-popin
                        id="customer-popin-id"
                        :title="currentVersion.customerPopinDto.customerPopinLabelsDto.title"
                        :text="currentVersion.customerPopinDto.customerPopinLabelsDto.text"
                        :button-label="currentVersion.customerPopinDto.customerPopinLabelsDto.buttonLabel"
                        :button-link="currentVersion.customerPopinDto.customerPopinLinksDto.buttonLink"
                        :link-label-html="currentVersion.customerPopinDto.customerPopinLabelsDto.linkLabelHtml"
                        :link="currentVersion.customerPopinDto.customerPopinLinksDto.link"
                    />
                </template>
                <div class="d-flex flex-column flex-md-row mt-1">
                    <!--/* Nom du device */-->
                    <h1 v-if="currentVersion" class="mb-0 mb-md-1 me-md-1">
                        {{ currentVersion.constructorName }}
                    </h1>
                    <!--/* rating-summary */-->
                    <ob1-rating
                        v-if="displayRatings"
                        class="item-summary align-items-end align-items-xl-start mt-0 mt-xl-1 mb-1 mb-md-0"
                        :average="currentVersion.reviewsStats.average"
                        :text="'('+currentVersion.reviewsStats.count+' avis)'"
                        :rating-results-height="1.375"
                        link="#anchor-reviews"
                        @ob1-rating-link.prevent="scrollToPageMenuAnchor('anchor-reviews')"
                    />
                </div>
                <div class="d-flex flex-column flex-md-row bg-white">
                    <!--/* img device */-->
                    <div class="d-flex flex-column info-device-width border-right-md border-gray2">
                        <div class="px-1 px-lg-2 py-1">
                            <div v-if="currentVersion" class="item-img">
                                <ob1-carrousel
                                    :id="'device-gallery'"
                                    :key="'device-gallery-' + currentVersion.seoId.value"
                                    :images="currentVersion.galleries"
                                    :is-product-sheet="true"
                                    :is-device-product-sheet="true"
                                    :image-overlay="mobileDetails.networkCompatibilityImage"
                                    :image-overlay-classes="'img-network-compatibility'"
                                    :image-rec-label-overlay="currentVersion.recqLabelImage"
                                    :rec-label-redirection-url="currentVersion.recqLabelRedirectionUrl"
                                    :with-zoom="true"
                                    :with-thumbnails="true"
                                />
                            </div>
                            <ob1-separateur v-if="asilage" class="my-1" />
                            <asilage
                                v-if="asilage"
                                :title="asilage.title"
                                :banner="asilage.banner"
                                :condition="asilage.condition"
                                :form-url="asilage.formUrl"
                                :image="asilage.image"
                                :condition-label="asilage.conditionLabel"
                            />
                            <!--/* number of views */-->
                            <view-counter
                                :counter-threshold="mobileDetails.views.counterThreshold"
                                :counter-delay="mobileDetails.views.counterDelay"
                                :message-template="mobileDetails.views.message"
                            />
                        </div>
                    </div>

                    <!--/* Pastilles + capacités */-->
                    <div class="w-100">
                        <div class="px-1 px-md-2 py-1">
                            <div class="d-md-flex justify-content-md-between flex-wrap">
                                <h2
                                    v-if="showDeclinaisonName"
                                    class="fw-bold no-signature standard mb-0 mb-lg-1 me-2"
                                    v-html="subtitle"
                                />

                                <div v-if="esimOnlyInfoLabel && esimOnlyInfoDescription" class="ob1-tooltip mb-1">
                                    <button type="button" class="ob1-tooltip-trigger ob1-link-icon ob1-link-icon-small">
                                        <span class="icon icon-SIM-E" aria-hidden="true" />
                                        <span class="ob1-link-icon-text" v-html="esimOnlyInfoLabel" />
                                    </button>
                                    <div class="ob1-tooltip-content py-0" :class="esimOnlyTooltipPosition">
                                        <div
                                            v-if="esimOnlyInfoDescription"
                                            class="fw-bold no-signature standard"
                                            v-html="esimOnlyInfoDescription"
                                        />
                                    </div>
                                </div>
                            </div>

                            <ob1-pastilles-de-couleurs
                                v-if="allColors.length > 0"
                                :id="'colors'"
                                :class="!showDeclinaisonName ? 'mt-2' : null"
                                class="mb-1"
                                :colors="allColors"
                                :default-color="mobileDetails.currentVersion.color ? mobileDetails.currentVersion.color.code : null"
                                @ob1-pastilles-de-couleurs-click="changeSelectedColor"
                            />

                            <fieldset>
                                <legend class="visually-hidden">
                                    Capacités disponibles
                                </legend>
                                <ob1-chips
                                    v-for="(capacity, index) in allCapacitiesBySelectedColor"
                                    :id="'capacity-' + index"
                                    :key="'capacity-' + index"
                                    :is-choice-version="true"
                                    :label="capacity.capacity"
                                    :is-disabled="!capacity.availableOnlineOrEresa"
                                    :is-checked="capacity.isChecked"
                                    :disable-uncheck="true"
                                    additional-classes="mb-1"
                                    @ob1-chips-click="changeSelectedCapacity"
                                />
                            </fieldset>
                            <!-- pour les mobiles reconditionnés -->
                            <ob1-separateur
                                v-if="allGradesBySelectedCapacityColor.length > 0"
                                class="d-md-none mb-2 mt-1"
                            />
                            <fieldset v-if="allGradesBySelectedCapacityColor.length > 0" class="mt-md-1">
                                <legend class="visually-hidden">
                                    Etat du mobile Reconditionné
                                </legend>
                                <ob1-chips
                                    v-for="(grade, index) in allGradesBySelectedCapacityColor"
                                    :id="'grade-' + index"
                                    :key="'grade-' + index"
                                    :is-choice-version="true"
                                    :label="grade.grade.label"
                                    :is-disabled="!grade.availableOnlineOrEresa"
                                    :is-checked="grade.isChecked"
                                    :disable-uncheck="true"
                                    additional-classes="mb-1"
                                    @ob1-chips-click="changeSelectedGrade(grade.grade.value)"
                                />
                            </fieldset>
                            <template v-if="allGradesBySelectedCapacityColor.length > 0">
                                <ob1-liens
                                    class="pt-0"
                                    is-button
                                    :with-arrow="true"
                                    data-bs-toggle="modal"
                                    modal-id="gradeModal"
                                    :text="'Pour en savoir plus, c\'est par ici'"
                                    data-oevent-category="comment_choisir_son_reconditionné"
                                    :data-oevent-action="getAction()"
                                    data-oevent-label="vers_popin"
                                />
                                <grade-popin
                                    :modal-id="'gradeModal'"
                                    :default-grade-id="currentVersion.grade.label"
                                    :labels="mobileDetails.gradeLabelsDto"
                                />
                            </template>
                            <!-- pour les mobiles reconditionnés -->
                            <ob1-separateur
                                v-if="allBatteriesBySelectedGradeCapacityColor.length > 0"
                                class="d-md-none mb-2 mt-1"
                            />
                            <fieldset v-if="allBatteriesBySelectedGradeCapacityColor.length > 0" class="my-md-1">
                                <legend class="visually-hidden">
                                    Etat de la batterie
                                </legend>
                                <ob1-chips
                                    v-for="(battery, index) in allBatteriesBySelectedGradeCapacityColor"
                                    :id="'battery-' + index"
                                    :key="'battery-' + index"
                                    :is-choice-version="true"
                                    :is-disabled="!battery.availableOnlineOrEresa"
                                    :label="battery.battery.label"
                                    :is-checked="battery.isChecked"
                                    :disable-uncheck="true"
                                    additional-classes="mb-1"
                                    @ob1-chips-click="changeSelectedBattery(battery.battery.value)"
                                />
                            </fieldset>

                            <!--/* Infos prix */-->
                            <div v-if="loading" class="d-flex justify-content-center">
                                <ob1-progress-indicators :size="50" type="undetermined" />
                            </div>
                            <template v-if="priceInfos">
                                <ob1-separateur class="my-1" />
                                <div class="d-lg-flex justify-content-between">
                                    <!--/* Prix */-->
                                    <div>
                                        <ob1-tag
                                            v-if="priceInfos.banner"
                                            :label="priceInfos.banner"
                                        />
                                        <promo-prix-terminal
                                            v-if="priceDevicePromoLabel"
                                            class="mt-1"
                                            :promo-label="priceDevicePromoLabel"
                                            :promo-end-date="priceDevicePromoEndDate"
                                        />
                                        <device-price
                                            class="d-block"
                                            :multiple-price="priceInfos.price.multiplePrice"
                                            :total-price-with-promo="priceInfos.price.totalPriceWithPromo"
                                            :total-price-without-promo="priceInfos.price.totalPriceWithoutPromo"
                                            :monthly-amount-in-cents="priceInfos.price.monthlyPayment ? priceInfos.price.monthlyPayment.monthlyAmountInCents : null"
                                            :monthly-duration="priceInfos.price.monthlyPayment ? priceInfos.price.monthlyPayment.duration : null"
                                            :taeg-rate="priceInfos.price.monthlyPayment ? priceInfos.price.monthlyPayment.taegRate : null"
                                            :generic-label="priceInfos.price.monthlyPayment ? priceInfos.price.monthlyPayment.genericLabel : null"
                                            :loan-rate-zero-label="loanRateZeroLabel"
                                            :is-cents-format="true"
                                            :is-price-inversion-enabled="isPriceInversionEnabledForDevice(priceInfos.price)"
                                        />
                                        <cb4x-pxf-mention
                                            v-if="priceInfos.price.paymentInfoLabel"
                                            :payment-info-detail="priceInfos.price.paymentInfoLabel.detail"
                                            :link-label="mobileDetails.paymentSolutionsDto.linkLabel"
                                            modal-id="popin-pxf-4xcb"
                                            is-from-mobile-detail
                                        />
                                        <!-- Popin de financement-->
                                        <pxf-cb4x-modal
                                            modal-id="popin-pxf-4xcb"
                                            :display-cb4x="priceInfos.price.isCb4xAvailable"
                                            :display-pxf="priceInfos.price.isPxfAvailable"
                                        >
                                            <template v-if="priceInfos.price.isCb4xAvailable" #cb4x-content>
                                                <!-- 4xCB payant  -->
                                                <paying-detail-cb4x-modal-content
                                                    v-if="fundingDetailsDto.cb4xPopin.withFees"
                                                    modal-id="popin-pxf-4xcb"
                                                    :oney-merchant-guid="fundingDetailsDto.cb4xPopin.oneyMerchantGuid"
                                                    :oney-widget-src="fundingDetailsDto.oneyWidgetSrc"
                                                    :counter-delay="fundingDetailsDto.counterDelay"
                                                    :amount="priceInfos.price.totalPriceWithPromo / 100"
                                                    :header-block="fundingDetailsDto.cb4xPopin.headerBlock"
                                                    :how-to-benefit="fundingDetailsDto.cb4xPopin.howToBenefit"
                                                    :cgu="fundingDetailsDto.cb4xPopin.cgu"
                                                    :illustration="fundingDetailsDto.cb4xPopin.imageZen"
                                                />
                                                <!-- 4xCB gratuit avec détail du prix  -->
                                                <cb4x-modal-content
                                                    v-else-if="priceInfos.price.spreadingPrice4xCbWithoutFees"
                                                    :header-block="fundingDetailsDto.cb4xPopin.headerBlock"
                                                    :payment-block="fundingDetailsDto.cb4xPopin.paymentBlock"
                                                    :payment-simulation-block="fundingDetailsDto.cb4xPopin.paymentSimulationBlock"
                                                    :how-to-benefit="fundingDetailsDto.cb4xPopin.howToBenefit"
                                                    :faq="fundingDetailsDto.cb4xPopin.faqBlock"
                                                    :cgu="fundingDetailsDto.cb4xPopin.cgu"
                                                    :monthly-price="priceInfos.price.spreadingPrice4xCbWithoutFees.monthlyPrice"
                                                    :first-monthly-price="priceInfos.price.spreadingPrice4xCbWithoutFees.firstMonthlyPrice"
                                                    :one-shot-price="priceInfos.price.spreadingPrice4xCbWithoutFees.oneShotPrice"
                                                    :illustration="fundingDetailsDto.cb4xPopin.imageZen"
                                                />
                                            </template>
                                            <!-- Payez en 12x, 24x, 36x ou 48x  -->
                                            <template v-if="priceInfos.price.isPxfAvailable" #pxf-content>
                                                <pxf-modal-content
                                                    :header-block-dto="fundingDetailsDto.pxfPopin.headerBlockDto"
                                                    :example-pxf-data="fundingDetailsDto.pxfPopin.examplePxfData"
                                                    :example-pxf-tab-subtitle="fundingDetailsDto.pxfPopin.examplePxfTabSubtitle"
                                                    :example-pxf-tab-title="fundingDetailsDto.pxfPopin.examplePxfTabTitle"
                                                    :version-pxf-data="priceInfos.price.versionPxfData"
                                                    :version-pxf-tab-title="fundingDetailsDto.pxfPopin.versionPxfTabTitle"
                                                    :pxf-legal-mentions-text="fundingDetailsDto.pxfPopin.pxfLegalMentionsText"
                                                    :illustration="fundingDetailsDto.pxfPopin.imageZen"
                                                    :financing-block="fundingDetailsDto.pxfPopin.financingBlock"
                                                    :cgu="fundingDetailsDto.pxfPopin.cguDto"
                                                    :how-to-benefit-dto="fundingDetailsDto.pxfPopin.howToBenefitDto"
                                                />
                                            </template>
                                        </pxf-cb4x-modal>
                                    </div>
                                </div>

                                <!--/* Prix téléphone seul */-->
                                <p
                                    v-if="currentVersionDataForIntention && currentVersionDataForIntention.complementaryPriceLabel"
                                    class="pb-0"
                                    v-html="currentVersionDataForIntention.complementaryPriceLabel"
                                />

                                <!--/* Infos prix */-->
                                <!--/* éco participation */-->
                                <eco-part-private-copying
                                    v-if="currentVersion.ecoParticipationDTO"
                                    :id="currentVersion.ecoParticipationDTO.ecoParticipationModal.id + '-modal'"
                                    :eco-part-label="currentVersion.ecoParticipationDTO.ecoParticipationLabel"
                                    :eco-part-link-label="currentVersion.ecoParticipationDTO.ecoParticipationLinkLabel"
                                    :eco-part-modal="currentVersion.ecoParticipationDTO.ecoParticipationModal"
                                    :private-copying-label="currentVersion.ecoParticipationDTO.privateCopyingLabel"
                                    :private-copying-link="currentVersion.ecoParticipationDTO.privateCopyingLink"
                                    :private-copying-link-label="currentVersion.ecoParticipationDTO.privateCopyingLinkLabel"
                                    :target="currentVersion.ecoParticipationDTO.ecoParticipationModal.target"
                                />

                                <!--/* Les garanties légales */-->
                                <div v-if="mobileDetails.showGuaranteeLegalMentions" class="small">
                                    <span v-html="mobileDetails.guaranteeLegalMentionsLabel" />
                                </div>

                                <!--/* Engagement */-->
                                <div
                                    v-if="currentVersionDataForIntention && currentVersionDataForIntention.commitment"
                                    class="pt-1"
                                >
                                    <strong
                                        v-if="currentVersionDataForIntention.commitment.withCommitment"
                                    >
                                        <p class="pb-0" v-html="currentVersionDataForIntention.commitment.text" />
                                    </strong>

                                    <ob1-message-alerte
                                        v-else
                                        :title="currentVersionDataForIntention.commitment.text"
                                        type="info"
                                    />
                                </div>
                            </template>

                            <!--/* message d'alerte en cas d'absence de commercialisation */-->
                            <template v-else>
                                <div class="col-12 pt-2 px-0 bg-white">
                                    <ob1-message-alerte
                                        v-if="!loading"
                                        :is-simple-alerte="false"
                                        :title="mobileDetails.alertStatusDto.title"
                                        :text="mobileDetails.alertStatusDto.message"
                                        :type="'warning'"
                                    />
                                </div>
                            </template>
                        </div>
                        <div
                            v-if="currentVersion && currentVersionDataForIntention"
                            class="px-1 px-md-2 pb-1"
                        >
                            <!--/* Promo + odr */-->
                            <template v-if="priceInfos && priceInfos.advantages">
                                <refunds
                                    :odrs="priceInfos.advantages.odrData"
                                    :device-seo-id="currentVersion.seoId.value"
                                    :refund-messages="mobileDetails.refundMessages"
                                    :recovery="priceInfos.advantages.recovery"
                                    :total-amount-in-cents="priceInfos.advantages.totalAmountInCents"
                                    :bonus-amount-format="bonusAmountFormat"
                                    :advantages-label="priceInfos.advantages.label"
                                    :simulator-modal-id="simulatorModalId"
                                    :simulator-result-modal-id="savedSimulationResultModalId"
                                    :recovery-modal-id="recoveryModalId"
                                />
                                <template v-if="hasRecovery">
                                    <mobile-recovery-simulator-modal
                                        :modal-id="simulatorModalId"
                                        :shop="shop"
                                        :messages="mobileDetails.refundMessages.recoverySimulator"
                                        @update-recovery-simulation="updateRecoveryPrice"
                                    />
                                    <mobile-recovery-simulation-result-modal
                                        v-if="priceInfos.advantages.recovery.manualEstimation"
                                        :modal-id="savedSimulationResultModalId"
                                        :shop="shop"
                                        :messages="mobileDetails.refundMessages.recoverySimulator.result"
                                        :estimated-device-price-in-cents="priceInfos.advantages.recovery.amountInCents"
                                        :estimated-device-model="priceInfos.advantages.recovery.deviceModel"
                                        :bonus="priceInfos.advantages.recovery.bonus"
                                        @new-simulation="newSimulation"
                                        @save-simulation="saveSimulation"
                                    />
                                    <mobile-recovery-simulation-result-modal
                                        :modal-id="currentSimulationResultModalId"
                                        :shop="shop"
                                        :messages="mobileDetails.refundMessages.recoverySimulator.result"
                                        :estimated-device-price-in-cents="estimatedDevice.recoveryPriceInCents"
                                        :estimated-device-model="estimatedDevice.model"
                                        :bonus="priceInfos.advantages.recovery.bonus"
                                        @new-simulation="newSimulation"
                                        @save-simulation="saveSimulation"
                                    />
                                    <mobile-recovery-details-modal
                                        :modal-id="recoveryModalId"
                                        :infos-recovery="mobileDetails.refundMessages.recoveryModal.infosRecovery"
                                        :online-recovery="currentVersionDataForIntention.onlineRecoveryAvailable ? mobileDetails.refundMessages.recoveryModal.onlineRecovery: null"
                                        :store-recovery="currentVersionDataForIntention.eligibleEresa ? mobileDetails.refundMessages.recoveryModal.storeRecovery : null"
                                        :bonus-recovery="mobileDetails.refundMessages.recoveryModal.bonusRecovery"
                                        :bonus="priceInfos.advantages.recovery.bonus"
                                        :recovery-simulator="mobileDetails.refundMessages.recoverySimulator"
                                        :simulator-button-label="mobileDetails.refundMessages.simulatorButtonLabel"
                                        :bonus-amount="bonusAmountFormat"
                                        :simulator-modal-id="simulatorModalId"
                                    />
                                </template>
                            </template>
                            <mobile-details-cta-acquisition
                                v-if="priceInfos"
                                :alert-status-dto="mobileDetails.alertStatusDto"
                                :button-label="mobileDetails.ctaLabel"
                                :all-disponibilities-popin="mobileDetails.allDisponibilitiesPopinLabelsDto"
                                :preorder-mention="currentVersion.preorderMention"
                                :available-online="currentVersionDataForIntention.inStockOnline"
                                :estimated-delivery-label="currentVersionDataForIntention.estimatedDeliveryLabel"
                                :available-eresa="currentVersionDataForIntention.eligibleEresa"
                                :offers-href="currentVersionDataForIntention.chooseOfferWithDeviceHref"
                                :offers-client-href="currentVersionDataForIntention.chooseAuthenticatedOfferWithDeviceHref"
                                :eresa-href="currentVersionDataForIntention.eresaOrderHref"
                                :online-href="currentVersionDataForIntention.onlineOrderHref"
                                :authentication-popin-labels="mobileDetails.authenticationPopinLabelsDto"
                            />

                            <!--/* Avantages */-->
                            <mobile-details-advantages
                                v-if="currentVersion.advantagesLabels && displayAdvantageMessage"
                                :is-authenticated="isAuthenticated"
                                :labels="currentVersion.advantagesLabels"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--/* Bandeau DAS / Batterie / Réparabilité */-->
        <div v-if="(currentVersion && currentVersion.repairability && currentVersion.repairability.picto) || mobileDetails.dasDTO" class="pt-1 pt-md-2 bg-gray2">
            <div class="container-fluid">
                <div class="row align-items-center pb-1">
                    <!--/* DAS */-->
                    <div v-if="mobileDetails.dasDTO" class="col-12 col-md-auto">
                        <das
                            class="my-1"
                            :head="mobileDetails.dasDTO.head"
                            :trunk="mobileDetails.dasDTO.trunk"
                            :member="mobileDetails.dasDTO.member"
                            :prefix="mobileDetails.dasDTO.prefix"
                            :popin-title="mobileDetails.dasDTO.popinTitle"
                            :popin-text="mobileDetails.dasDTO.popinDescription"
                            :is-sosh-shop="isSoshShop"
                        />
                    </div>

                    <!--/* Batterie(Charger) */-->
                    <div v-if="mobileDetails.chargerIncluded" class="col-12 col-md-auto my-1 my-md-0 mx-md-2 px-md-0">
                        <div class="d-flex align-items-center">
                            <div class="icon icon-charger-availability charger-icon-size ps-1 ps-md-0 text-gray4" aria-hidden="true" />
                            <strong class="ps-3 ps-md-0" v-html="mobileDetails.chargerIncludedMessage" />
                        </div>
                    </div>
                    <div v-else-if="mobileDetails.chargerCompatibleInfosDTO" class="col-12 col-md-auto my-1 my-md-0 mx-md-2 px-md-0">
                        <ChargerInfos :is-sosh-shop="isSoshShop" :charger-infos="mobileDetails.chargerCompatibleInfosDTO" />
                    </div>

                    <!--/* Réparabilité */-->
                    <div v-if="currentVersion && currentVersion.repairability && currentVersion.repairability.picto" class="col-12 col-md-auto">
                        <repairability
                            :picto="currentVersion.repairability.picto"
                            :note="currentVersion.repairability.note"
                            :label="mobileDetails.repairabilityMessagesDto.label"
                            :title-popin="mobileDetails.repairabilityMessagesDto.label"
                            :text-popin="mobileDetails.repairabilityMessagesDto.textPopin"
                            :link-document="mobileDetails.repairabilityMessagesDto.linkDocument"
                            :url-document="currentVersion.repairability.urlDocument"
                        />
                    </div>
                    <div v-if="mobileDetails.energyLabel" class="col-12 col-md-auto">
                        <energy-label :energy-label="mobileDetails.energyLabel" />
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <!--/* Financing */-->
            <section v-if="shouldDisplayPXFMention">
                <pxf-description
                    :pxf-legal-mentions-text="pxfLegalMentionsText"
                />
                <ob1-separateur
                    class="my-2 mb-xl-3"
                />
                <div class="row">
                    <div class="col-12">
                        <financing-mentions :financing-mentions="financingMentions" />
                    </div>
                </div>
            </section>

            <!--/* Historique navigation */-->
            <div v-if="loading" class="container-fluid">
                <skeleton-mobiles-views-history-card />
            </div>
            <template v-else>
                <mobiles-views-history
                    v-if="mobilesViewsHistory"
                    :title="navigationHistoryTitle"
                    :track-zone="viewedMobilesTag"
                    :mobiles="mobilesViewsHistory.mobiles"
                    is-from-mobile-detail
                    :intention="intentionParam"
                />
            </template>

            <!--/* Page Menu */-->
            <ob1-page-menu
                v-if="pageMenu"
                id="device-details-page-menu"
                :tabs="pageMenu"
                class="sticky bg-white mb-2"
                @ob1-page-menu-click="scrollToPageMenuAnchor"
            />

            <!--/* Push Zigzag */-->
            <section v-if="mobileDetails.pushZigZagDTO">
                <div class="mb-xl-3" />
                <header-signature :text="mobileDetails.essentialTitle" />
                <push-zig-zag :zigzag="mobileDetails.pushZigZagDTO" />
            </section>

            <!--/* Fiche technique */-->
            <section v-if="mobileDetails.technicalSheetDTO">
                <ob1-separateur class="my-2 mb-xl-3" />
                <technical-sheet
                    :technical-sheet-dto="mobileDetails.technicalSheetDTO"
                    :refurbished-characteristic-dto="currentVersion.refurbishedCharacteristicDTO"
                />
            </section>

            <!--/* La Reprise */-->
            <template v-if="hasRecovery">
                <section class="mb-2 mb-md-3">
                    <ob1-separateur class="my-2" />
                    <header-signature :text="mobileRecovery.messages.title" />
                    <mobile-recovery
                        id="anchor-mobile-recovery"
                        :recovery-amount-in-cents="recoveryAmountInCents"
                        :recovery-device-model="recoveryDeviceModel"
                        :manual-estimation="recoveryManualEstimation"
                        :bonus-amount-in-cents="bonusAmountInCents"
                        :simulator-modal-id="simulatorModalId"
                        :recovery-modal-id="recoveryModalId"
                        :messages="mobileRecovery.messages"
                        :visual="mobileRecovery.visual"
                        :shop="shop"
                    />
                </section>
            </template>

            <!--/* Les garanties légales */-->
            <section v-if="mobileDetails.showGuaranteeLegalMentions">
                <ob1-separateur class="my-2 mb-xl-3" />
                <guarantee-legal-mentions :legal-mentions="deviceMentions" />
            </section>

            <!--/* Eco Rating */-->
            <section
                v-if="currentVersion && currentVersion.ecoRating"
            >
                <eco-rating :eco-rating="currentVersion.ecoRating" />
            </section>

            <template v-if="mobileDetails.showRetailLegalMentions">
                <!--/* Reconditionnés */-->
                <ob1-separateur class="my-2 mb-xl-3" />
                <header-signature :text="mobileDetails.retailLegalMentionsTitle" />
                <div id="anchor-reconditioned" class="row align-items-baseline">
                    <div class="col-12 d-flex align-items-center mb-1">
                        <div v-html="deviceMentions.retailMentiontext" />
                    </div>
                </div>
            </template>
            <!--/* Avis clients */-->
            <template v-if="displayRatings">
                <section class="mb-2 mb-md-3">
                    <ob1-separateur class="my-2" />
                    <header-signature :text="mobileDetails.reviewsMessages.title" />
                    <device-average-rating-reviews
                        :average-ratings="deviceAverageRatingReviews.averageRatings"
                        :reviews-stats-average="currentVersion.reviewsStats.average"
                        :reviews-stats-text="'('+currentVersion.reviewsStats.count+' avis)'"
                        :loading="deviceAverageRatingReviews.loading"
                        :reviews-messages="mobileDetails.reviewsMessages"
                    />
                    <device-filter-and-details-reviews
                        :device-details-reviews="deviceDetailsReviews"
                        :device-filter-reviews="deviceFilterReviews"
                        :reviews-messages="mobileDetails.reviewsMessages"
                        :ratings-filter-checkboxes="ratingsFilterCheckboxes"
                        @update-ratings-filter-handler="updateRatingsFilterHandler"
                        @more-device-reviews="getMoreDeviceReviews"
                    />
                </section>
            </template>

            <!--/* Zone environmental */-->
            <ob1-liens
                v-if="mobileDetails.environmentalQualityDTO"
                class="mw-100 py-0"
                :href="mobileDetails.environmentalQualityDTO.url"
                :text="mobileDetails.environmentalQualityDTO.linkLabel"
                :with-arrow="true"
                :is-mini="true"
                target="_blank"
            />
        </div>

        <div class="bg-gray2 mt-1 pt-1 pb-1">
            <div class="container-fluid">
                <!--/* Zone Kit mains libres */-->
                <free-hands
                    :text="mobileDetails.freeHandsText"
                />
                <legal-mentions4x-cb
                    v-if="priceInfos && priceInfos.price.paymentInfoLabel && priceInfos.price.paymentInfoLabel.type === 'CB4X'"
                    :label="mobileDetails.legalMentions.cb4xMention"
                    :popin4x-cb="mobileDetails.legalMentions.popin4xCb"
                />
            </div>
        </div>

        <!--/* Zone Engagements */-->
        <div v-if="isSoshShop" class="container-fluid">
            <sosh-commitments :commitments="mobileDetails.soshCommitments" />
        </div>
        <div v-else class="bg-dark d-webview-none">
            <div class="container-fluid">
                <orange-commitments :commitments="mobileDetails.orangeCommitments" />
            </div>
        </div>

        <!--/* Zone Fil d'ariane */-->
        <div class="d-webview-none" :class="isSoshShop ? 'bg-gray2 py-1' : 'bg-dark py-1'">
            <div class="container-fluid">
                <ob1-breadcrumb :is-inverse="!isSoshShop" :items="breadcrumbItems" />
            </div>
        </div>
    </div>
</template>

<script>
import SelectedOffer from "../../common/SelectedOffer";
import Refunds from "../../common/components/Refunds.vue";
import GradePopin from "../../common/components/GradePopin";
import FreeHands from "../../../common/components/FreeHands";
import Repairability from "../../common/Repairability";
import {ColorSorter} from "../mixins/ColorSorter";
import Das from "../../common/components/Das";
import EcoRating from "../../common/components/EcoRating";
import Incentive from "../../common/components/Incentive.vue";
import IntentionSwitch from "../../common/components/IntentionSwitch";
import ViewCounter from "../../common/components/ViewCounter.vue";
import mobileDetailsAdvantages from "./MobileDetailsAdvantages.vue";
import PushZigZag from "../../../common/fragments/mobile/PushZigZag.vue";
import technicalSheet from "../../common/fragments/TechnicalSheet.vue";
import OrangeCommitments from "../../common/components/OrangeCommitments.vue";
import GuaranteeLegalMentions from "../../common/components/GuaranteeLegalMentions.vue";
import {scrollToElement} from "../Util";
import CustomerPopin from "../../common/components/CustomerPopin.vue";
import PxfDescription from "../../../common/fragments/mobile/PxfDescription.vue";
import Cb4xPxfMention from "../../../common/fragments/mobile/Cb4xPxfMention.vue";
import PxfCb4xModal from "../../common/components/PxfCb4xModal.vue";
import Cb4xModalContent from "../../common/components/Cb4xModalContent.vue";
import PxfModalContent from "../../common/components/PxfModalContent.vue";
import ContractPhoneLines from "../../common/ContractPhoneLines.vue";
import HeaderSignature from "../../../common/components/vue/HeaderSignature.vue";
import SoshCommitments from "../../common/components/SoshCommitments.vue";
import MobileDetailsCtaAcquisition from "./MobileDetailsCtaAcquisition.vue";
import MobilesViewsHistory from "../../common/navigationhistory/MobilesViewsHistory.vue";
import {fetchMobilesViewsHistory} from "../navigationhistory/HistoryMobilesApi";
import SkeletonMobilesViewsHistoryCard from "../../common/navigationhistory/SkeletonMobilesViewsHistoryCard.vue";
import PayingDetailCb4xModalContent from "../../common/components/PayingDetailCb4xModalContent.vue";
import Asilage from "../../common/components/Asilage.vue";
import FinancingMentions from "../../common/components/FinancingMentions.vue";
import DeviceAverageRatingReviews from "../../common/devicereviews/DeviceAverageRatingReviews.vue";
import DeviceFilterAndDetailsReviews from "../../common/devicereviews/DeviceFilterAndDetailsReviews.vue";
import PromoPrixTerminal from "../../common/PromoPrixTerminal.vue";
import ChargerInfos from "../ChargerInfos.vue";
import LegalMentions4xCb from "../components/LegalMentions4xCb.vue";
import MobileRecovery from "../mobilerecovery/MobileRecovery.vue";
import MobileRecoverySimulatorModal from "../MobileRecoverySimulatorModal.vue";
import MobileRecoveryDetailsModal from "../MobileRecoveryDetailsModal.vue";
import MobileRecoverySimulationResultModal from "../MobileRecoverySimulationResultModal.vue";
import EnergyLabel from "../EnergyLabel.vue";
import DevicePrice from "../../../common/components/ob1/DevicePrice.vue";
import EcoPartPrivateCopying from "../../common/fragments/EcoPartPrivateCopying.vue";

const mobileDetailsDTO = JSON.parse(document.getElementById('mobile-details').dataset.mobileDetails);

const ACQUISITION_PARAM = "acquisition";
const RENOUVELLEMENT_PARAM = "renouvellement";
const TSEUL_PARAM = "terminal-seul";
const PCM_PARAM = "pcm";
const CHANGER_DE_MOBILE_PARAM = "changer-de-mobile";

export default {
    name: "MobileDetails",
    components: {
        EcoPartPrivateCopying,
        DevicePrice,
        EnergyLabel,
        MobileRecoverySimulationResultModal,
        MobileRecovery,
        MobileRecoveryDetailsModal,
        MobileRecoverySimulatorModal,
        LegalMentions4xCb,
        ChargerInfos,
        PromoPrixTerminal,
        FinancingMentions,
        DeviceFilterAndDetailsReviews,
        DeviceAverageRatingReviews,
        Asilage,
        SkeletonMobilesViewsHistoryCard,
        MobilesViewsHistory,
        PayingDetailCb4xModalContent,
        MobileDetailsCtaAcquisition,
        SoshCommitments,
        HeaderSignature,
        CustomerPopin,
        ContractPhoneLines,
        PxfModalContent,
        Cb4xModalContent,
        Cb4xPxfMention,
        PxfDescription,
        SelectedOffer,
        Refunds,
        FreeHands,
        Repairability,
        Das,
        EcoRating,
        Incentive,
        IntentionSwitch,
        ViewCounter,
        mobileDetailsAdvantages,
        technicalSheet,
        PushZigZag,
        OrangeCommitments,
        GuaranteeLegalMentions,
        PxfCb4xModal,
        GradePopin
    },
    mixins: [ColorSorter],
    data() {
        return {
            mobileDetails: mobileDetailsDTO,
            deviceDetailsBySeoId: null,
            fundingDetailsDto: mobileDetailsDTO.fundingDetailsDto,
            deviceMentions: mobileDetailsDTO.deviceMentions,
            financingMentions: mobileDetailsDTO.financingMentions,
            loading: true,
            isPriceInversionEnabled: mobileDetailsDTO.priceInversionEnabled,
            loanRateZeroLabel: mobileDetailsDTO.loanRateZeroLabel,
            shop: mobileDetailsDTO.shop,
            universe: mobileDetailsDTO.universe,
            selectedOffer: mobileDetailsDTO.selectedOffer,
            continueButtonDisabled: false,
            autoScrollEnabled: true,
            carrousel: null,
            dasDescription: mobileDetailsDTO.dasDescription,
            breadcrumbItems: mobileDetailsDTO.filArianeDTO.items,
            intentionParam: mobileDetailsDTO.defaultIntention,
            pxfLegalMentionsText: mobileDetailsDTO.pxfLegalMentionsText,
            deviceDetailsReviews: {
                totalNumber: 0,
                blocSize: 10,
                reviews: [],
                offset: 0,
                loading: true
            },
            deviceFilterReviews: {
                ratingsFilter: [],
                loading: true
            },
            deviceAverageRatingReviews: {
                averageRatings: [],
                loading: true
            },
            msisdn: mobileDetailsDTO.msisdn,
            mobilesViewsHistory: null,
            currentVersion: mobileDetailsDTO.currentVersion,
            selectedRatingsFilter: [],
            esimOnlyTooltipPosition: null,
            mobileRecovery: mobileDetailsDTO.mobileRecovery,
            estimatedDevice: {
                recoveryPriceInCents: undefined,
                model: undefined
            },
            simulatorModalId: "mobile-recovery-simulator",
            currentSimulationResultModalId: "current-mobile-recovery-simulation-result",
            savedSimulationResultModalId: "saved-mobile-recovery-simulation-result",
            recoveryModalId: "mobile-recovery-popin"
        }
    },
    computed: {
        isSoshShop() {
            return this.shop === 'SOSH'
        },
        currentVersionDataForIntention: function () {
            return this.deviceDetailsBySeoId?.[this.currentVersion.seoId.value]
        },
        priceInfos() {
            return this.currentVersionDataForIntention?.priceInfos;
        },
        asilage() {
            return this.currentVersionDataForIntention?.asilage;
        },
        shouldDisplayPXFMention() {
            if (this.priceInfos) {
                return this.priceInfos.price.isPxfAvailable
            } else return false
        },
        allVersions: function () {
            return mobileDetailsDTO.allVersions
        },
        pageMenu: function() {
            // On ne garde l'onglet Reprise que si la reprise est disponible
            if (mobileDetailsDTO.pageMenuDTO)
            return mobileDetailsDTO.pageMenuDTO.tabs.filter((tab) => tab.id !== "anchor-mobile-recovery" || this.hasRecovery)
            else return [];
        },
        allColors: function () {
            const colors = [];
            for (const version of this.allVersions) {
                const versionColor = version.color;
                if (versionColor && !colors.find(color => color.code === versionColor.code)) {
                    colors.push(
                        {
                            colorName: versionColor.colorName,
                            code: versionColor.code,
                            isChecked: this.checkedColor && this.checkedColor.code === versionColor.code,
                            inputName: versionColor.inputName,
                        }
                    );
                }
            }

            return this.sortColors(colors);
        },
        checkedColor: function () {
            return this.currentVersion.color;
        },
        allCapacitiesBySelectedColor: function () {
            const capacitiesByColor = [];
            for (const capacity of this.mobileDetails.allCapacities) {
                let versionOfCapacityAndCheckedColor = this.allVersions.find(version => version.capacity?.label === capacity && version.color?.code === this.checkedColor?.code);
                if (versionOfCapacityAndCheckedColor != null) {
                    capacitiesByColor.push({
                        capacity: capacity,
                        isChecked: this.checkedCapacity && this.checkedCapacity.label === capacity,
                        availableOnlineOrEresa: !!this.checkedGrade ? true : this.availableOnlineOrEresa(versionOfCapacityAndCheckedColor.seoId.value)
                    });
                }
            }
            return capacitiesByColor;
        },
        checkedCapacity: function () {
            return this.currentVersion.capacity;
        },
        allGradesBySelectedCapacityColor: function () {
            const gradesByCapacity = [];
            for (const grade of this.mobileDetails.allGrades) {
                let versionOfGradeAndCheckedCapacityColor = this.allVersions.find(version => version.grade?.label === grade?.value && version.color?.code === this.checkedColor?.code && version.capacity?.label === this.checkedCapacity?.label);
                if (versionOfGradeAndCheckedCapacityColor != null) {
                    gradesByCapacity.push({
                        grade: grade,
                        isChecked: this.checkedGrade && this.checkedGrade.label === grade?.value,
                        availableOnlineOrEresa: !!this.checkedBattery ? true : this.availableOnlineOrEresa(versionOfGradeAndCheckedCapacityColor.seoId.value)
                    });
                }
            }
            return gradesByCapacity;
        },
        checkedGrade: function () {
            return this.currentVersion.grade;
        },
        allBatteriesBySelectedGradeCapacityColor: function () {
            const batteriesByGrade = [];
            for (const battery of this.mobileDetails.allBatteries) {
                let versionOfBatteryAndCheckedGradeCapacityColor = this.allVersions.find(version => version.battery?.label === battery?.value && version.color?.code === this.checkedColor?.code && version.capacity?.label === this.checkedCapacity?.label && version.grade?.label === this.checkedGrade?.label)
                if (versionOfBatteryAndCheckedGradeCapacityColor != null) {
                    batteriesByGrade.push({
                        battery: battery,
                        isChecked: this.checkedBattery && this.checkedBattery.label === battery?.value,
                        availableOnlineOrEresa: this.availableOnlineOrEresa(versionOfBatteryAndCheckedGradeCapacityColor.seoId.value)
                    });
                }
            }
            return batteriesByGrade;
        },
        checkedBattery: function () {
            return this.currentVersion.battery;
        },
        isAuthenticated() {
            return this.mobileDetails.authenticated;
        },
        showDeclinaisonName() {
            return this.currentVersion.declinaisonName !== this.currentVersion.constructorName
        },
        esimOnlyInfoLabel() {
            return this.mobileDetails.esimOnlyInfo?.label;
        },
        esimOnlyInfoDescription() {
            return this.mobileDetails.esimOnlyInfo?.description;
        },
        pageMenuOffsetHeight: function () {
            if (document.querySelector('#device-details-page-menu')) {
                return document.querySelector('#device-details-page-menu').offsetHeight;
            }
            return 0;
        },
        priceDevicePromo() {
            return this.priceInfos.promoValues?.promoData
        },
        priceDevicePromoEndDate() {
            return this.priceDevicePromo?.endDate
        },
        priceDevicePromoLabel() {
            return this.priceDevicePromo?.promoLabel
        },
        hasRecovery() {
            return this.priceInfos?.advantages?.recovery != null;
        },
        hasMobileBonusRecovery() {
            return this.priceInfos?.advantages?.recovery?.bonus != null;
        },
        recoveryAmountInCents() {
            return this.priceInfos?.advantages?.recovery?.amountInCents;
        },
        recoveryDeviceModel() {
            return this.priceInfos?.advantages?.recovery?.deviceModel;
        },
        recoveryManualEstimation() {
            return this.priceInfos?.advantages?.recovery?.manualEstimation;
        },
        bonusAmountInCents() {
            return this.priceInfos?.advantages?.recovery?.bonus?.amountInCents;
        },
        bonusAmountFormat() {
            let amountInCents = this.bonusAmountInCents;
            if (amountInCents) {
                return PriceFormatter.formatEurosWithSpace(amountInCents / 100, false).toString();
            } else {
                return null;
            }
        },
        displayRatings() {
            return !!this.currentVersion.reviewsStats;
        },
        subtitle() {
            let subtitle = `${this.currentVersion.brand} ${this.currentVersion.declinaisonName}`;
            if (this.priceInfos?.banner) {
                return `${this.priceInfos.banner} ${subtitle}`;
            } else {
                return `${subtitle}`;
            }
        },
        showNavigationHistory() {
            return this.mobileDetails.historyNavigationDto.searchHistoryEnabled;
        },
        viewedMobilesTag() {
            return this.mobileDetails.viewedMobilesTag;
        },
        navigationHistoryTitle() {
            return this.mobileDetails.historyNavigationDto.title;
        },
        ratingsFilterCheckboxes() {
            return this.deviceFilterReviews.ratingsFilter.map(rating => {
                return {
                    label: rating.label,
                    isChecked: this.selectedRatingsFilter.includes(rating.id),
                    count: rating.count,
                    id: rating.id,
                }
            })
        },
        displayAdvantageMessage() {
            return this.intentionParam === ACQUISITION_PARAM || this.intentionParam === TSEUL_PARAM
        }
    },
    created: function () {
        // Scrute le déplacement dans la page, pour mettre à jour la section consultée dans la barre de menu sticky
        document.addEventListener('scroll', () => {
            if (this.pageMenu && this.autoScrollEnabled) {
                updatePageMenu('device-details-page-menu', this.pageMenu.map(tab => "#" + tab.id));
            }
        });
    },
    mounted: function () {
        jQuery(document).ready(()  => {
            Array.from(document.querySelectorAll('.item-img .ob1-carrousel-product-sheet')).forEach((carrousel) => {
                    this.carrousel = new ob1.Carrousel(carrousel, false);
                }
            );

            this.loadDeviceDetails()
                .then(detailsBySeoId => {
                        this.deviceDetailsBySeoId = detailsBySeoId;
                        this.loadMobilesViewsHistory().then(
                            this.loadDeviceReviews()
                        )
                    }
                )
                .catch(() => window.location.href = this.mobileDetails.infoViewUrl);

            this.updateBreadCrumbWithIntention();


            window.addEventListener("resize", () => {
                this.updateLayout();
            });

            this.updateLayout();

            const customerPopin = $('#customer-popin-id');
            if (this.mobileDetails.displayCustomerPopin) {
                customerPopin.modal('show');
            }
        })
    },
    methods: {
        scrollToPageMenuAnchor: function (id) {
            const element = document.getElementById(id);
            if (element) {
                // on ajoute 2px pour trigger l'événement de changement d'onglet et que le bon soit indiqué comme actif
                scrollToElement(element, {dx: 0, dy: -this.pageMenuOffsetHeight + 2});
            }
        },
        changeSelectedColor: function (newColor) {
            // On cherche un duo couleur / capacité / grade et battery présent dans toutes les versions en stock en ligne ou en click and collect
            let searchedVersion = this.allVersions.find(version =>
                version.color?.code === newColor?.code
                && version.capacity?.label === this.checkedCapacity?.label
                && version.grade?.label === this.checkedGrade?.label
                && version.battery?.label === this.checkedBattery?.label
                && this.availableOnlineOrEresa(version.seoId.value));
            if (!searchedVersion) {
                // Si n'a pas trouvé de version, on cherche sans la batterie
                searchedVersion = this.allVersions.find(version =>
                    version.color?.code === newColor?.code
                    && version.capacity?.label === this.checkedCapacity?.label
                    && version.grade?.label === this.checkedGrade?.label
                    && this.availableOnlineOrEresa(version.seoId.value));
            }
            if (!searchedVersion) {
                // Si n'a pas trouvé de version, on cherche sans le grade
                searchedVersion = this.allVersions.find(version =>
                    version.color?.code === newColor?.code
                    && version.capacity?.label === this.checkedCapacity?.label
                    && this.availableOnlineOrEresa(version.seoId.value));
            }
            if (!searchedVersion) {
                // Si n'a pas trouvé de version, on cherche sans la capacité
                searchedVersion = this.allVersions.find(version =>
                    version.color?.code === newColor?.code
                    && this.availableOnlineOrEresa(version.seoId.value));
            }
            if (!searchedVersion) {
                // Si n'a pas trouvé de version, on cherche sans la disponibilité
                searchedVersion = this.allVersions.find(version =>
                    version.color?.code === newColor?.code);
            }
            // On met à jour la currentVersion
            if (searchedVersion !== undefined) this.currentVersion = searchedVersion;

            this.updateInfos();
        },
        changeSelectedCapacity: function (newCapacity) {
            // On cherche un duo couleur / capacité / grade et battery présent dans toutes les versions en stock en ligne ou en click and collect
            let searchedVersion = this.allVersions.find(version =>
                version.color?.code === this.checkedColor?.code
                && version.capacity?.label === newCapacity
                && version.grade?.label === this.checkedGrade?.label
                && version.battery?.label === this.checkedBattery?.label
                && this.availableOnlineOrEresa(version.seoId.value));
            if (!searchedVersion) {
                // Si n'a pas trouvé de version, on cherche sans la batterie
                searchedVersion = this.allVersions.find(version =>
                    version.color?.code === this.checkedColor?.code
                    && version.capacity?.label === newCapacity
                    && version.grade?.label === this.checkedGrade?.label
                    && this.availableOnlineOrEresa(version.seoId.value));
            }
            if (!searchedVersion) {
                // Si n'a pas trouvé de version, on cherche sans le grade
                searchedVersion = this.allVersions.find(version =>
                    version.color?.code === this.checkedColor?.code
                    && version.capacity?.label === newCapacity
                    && this.availableOnlineOrEresa(version.seoId.value));
            }
            if (!searchedVersion) {
                // Si n'a pas trouvé de version, on cherche sans la disponibilité
                searchedVersion = this.allVersions.find(version =>
                    version.color?.code === this.checkedColor?.code
                    && version.capacity?.label === newCapacity);
            }

            // On met à jour la currentVersion
            if (searchedVersion !== undefined) this.currentVersion = searchedVersion;

            this.updateInfos();
        },
        changeSelectedGrade: function (newGrade) {
            // On cherche un duo couleur / capacité / grade et battery présent dans toutes les versions en stock en ligne ou en click and collect
            let searchedVersion = this.allVersions.find(version =>
                version.color?.code === this.checkedColor?.code
                && version.capacity?.label === this.checkedCapacity?.label
                && version.grade?.label === newGrade
                && version.battery?.label === this.checkedBattery?.label
                && this.availableOnlineOrEresa(version.seoId.value));
            if (!searchedVersion) {
                // Si n'a pas trouvé de version, on cherche sans la batterie
                searchedVersion = this.allVersions.find(version =>
                    version.color?.code === this.checkedColor?.code
                    && version.capacity?.label === this.checkedCapacity?.label
                    && version.grade?.label === newGrade
                    && this.availableOnlineOrEresa(version.seoId.value));
            }
            if (!searchedVersion) {
                // Si n'a pas trouvé de version, on cherche sans la disponibilité
                searchedVersion = this.allVersions.find(version =>
                    version.color?.code === this.checkedColor?.code
                    && version.capacity?.label === this.checkedCapacity?.label
                    && version.grade?.label === newGrade);
            }
            // On met à jour la currentVersion
            if (searchedVersion !== undefined) this.currentVersion = searchedVersion;

            this.updateInfos();
        },
        changeSelectedBattery: function (newBattery) {

            // On met à jour la currentVersion
            this.currentVersion = this.allVersions.find(version =>
                version.color?.code === this.checkedColor?.code
                && version.capacity?.label === this.checkedCapacity?.label
                && version.grade?.label === this.checkedGrade?.label
                && version.battery?.label === newBattery);

            this.updateInfos();
        },
        updateInfos() {
            // On met à jour l'url
            this.urlHandler();

            // On met à jour le fil d'ariane
            this.breadcrumbHandler();

            // On met à jour le datalayer
            this.updateDatalayerForVariation();
        },
        inStockOnline: function (seoId) {
            return this.deviceDetailsBySeoId?.[seoId]?.inStockOnline
        },
        eligibleEresa: function (seoId) {
            return this.deviceDetailsBySeoId?.[seoId]?.eligibleEresa
        },
        availableOnlineOrEresa: function (seoId) {
            return this.inStockOnline(seoId) || this.eligibleEresa(seoId);
        },
        urlHandler: function () {
            // On met à jour l'url avec le seoId de la sélection
            const slug = window.location.href.substring(
                window.location.href.lastIndexOf("/") + 1
            );
            const parameterIndex = window.location.href.lastIndexOf("?");
            const parameters = parameterIndex === -1 ? "" : window.location.href.substring(parameterIndex);
            const fullUrlWithoutSlug = window.location.href.substring(
                0, window.location.href.lastIndexOf(slug)
            );
            const newUrl = fullUrlWithoutSlug + this.currentVersion.seoId.value + parameters;
            window.history.replaceState({}, null, newUrl);
        },
        breadcrumbHandler: function () {
            const breadcrumbLength = this.breadcrumbItems.length
            this.breadcrumbItems.splice(breadcrumbLength - 1, 1, {name: this.currentVersion.declinaisonName})
        },
        handleBackLink: function (event) {
            event.preventDefault();

            const tmsDto = this.mobileDetails.back.tmsDto;
            if (tmsDto !== undefined) {
                Tms.link({category: tmsDto.tagZone, action: tmsDto.tagName, label: this.mobileDetails.back.link});
            }

            let selectorIntention = this.getSelectorIntention(this.intentionParam)

            if (this.mobileDetails.back.forcedBackUrlSelector) {
                history.back();
            } else {
                // On propage le paramètre d'intention si pas déjà présent
                if (selectorIntention && this.getParam(this.mobileDetails.back.link, "intention") === "") {
                    window.location = addParam(this.mobileDetails.back.link, "intention=" + selectorIntention);
                } else if (selectorIntention) {
                    // mise à jour du paramètre d'intention dans l'url
                    window.location = setParam(this.mobileDetails.back.link, "intention", selectorIntention);
                } else {
                    window.location = this.mobileDetails.back.link;
                }
            }

        },
        getSelectorIntention: function (intentionParam) {
            let intention = intentionParam
            if (intentionParam === PCM_PARAM || intentionParam === RENOUVELLEMENT_PARAM) {
                intention = CHANGER_DE_MOBILE_PARAM
            }
            return intention;
        },
        loadDeviceDetails: function () {
            return new Promise((resolve, reject) => {
                this.loading = true;
                this.fetchDeviceDetails().then(result => {
                    this.loading = false;
                    resolve(result.detailsBySeoId);
                }).catch((error) => {
                    if (window.MyShop?.crashLogReporter) {
                        let reporter = window.MyShop.crashLogReporter;
                        reporter.logError(error).then(() => {
                            reject();
                        });
                    }
                    this.loading = false;
                    reject();
                });
            })
        },
        fetchDeviceDetails: function () {
            let url = "/api/mobile/device-details"
            return new Promise((resolve, reject) => {
                $.ajax({
                    method: "GET",
                    data: {
                        "shop": this.shop,
                        "universe": this.universe,
                        "intention": this.intentionParam,
                        "device": this.currentVersion.seoId.value,
                        "offer": this.selectedOffer ? this.selectedOffer.offerSeoId : undefined
                    },
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    url: url,
                    contentType: "application/json",
                    dataType: "json"
                }).done(result => {
                    resolve(result)
                }).fail(error => {
                    reject(error)
                })
            });
        },
        formattedDevicePrice: function () {
            if (!this.priceInfos) {
                return null;
            }
            let price = this.priceInfos.price.totalPriceWithPromo /100;
            return price.toString().replace(".", ",");
        },
        updateDatalayerForVariation: function () {
            let checkedGradeLabel = this.checkedGrade !== undefined ? " " + this.checkedGrade.label : ""
            let checkedBatteryLabel = this.checkedBattery !== undefined ? " " + this.checkedBattery.label : ""
            if (tmsData) {
                tmsData.offre_id = this.currentVersion.ean.value
                tmsData.offre_libelle = this.currentVersion.declinaisonName + checkedGradeLabel + checkedBatteryLabel
                tmsData.offre_modele = this.currentVersion.declinaisonName
                tmsData.offre_prix_ttc = this.formattedDevicePrice()

                if (this.hasMobileBonusRecovery) {
                    tmsData.bonus_reprise = "true"
                } else {
                    tmsData.bonus_reprise = "false"
                }

                Tms.view(tmsData);
            }
        },
        getParam: function (url, paramName) {
            let param = getParameterByName(paramName, url)
            if (param === null || param === undefined) {
                param = ""
            }
            return param;
        },
        updateBreadCrumbWithIntention() {
            this.breadcrumbItems = this.breadcrumbItems.map(item => ({
                name: item.name,
                url: this.updateSelectorUrlWithIntention(item.url)
            }))
        },
        updateSelectorUrlWithIntention(url) {
            if (url) {
                if (this.getParam(url, "intention") === "") {
                    return addParam(url, "intention=" + this.intentionParam)
                }
                return setParam(url, "intention", this.intentionParam)
            }
            return null
        },
        switchIntention(selectedId) {

            if (this.shop === "ORANGE" && (this.intentionParam === RENOUVELLEMENT_PARAM || this.intentionParam === PCM_PARAM)) {
                // On est sur la fiche détail PCM/renouvellement
                // On recharge la page pour changer d'intention
                if (selectedId === "intention-acquisition") {
                    location.href = this.currentVersion.acquisitionMobileDetailsUrl
                } else if (selectedId === "intention-tseul") {
                    location.href = this.currentVersion.tseulMobileDetailsUrl
                }
            } else if (this.shop === "ORANGE" && selectedId === "intention-changer-de-mobile") {
                location.href = this.currentVersion.changerDeMobileDetailsUrl
            } else if (this.currentVersion.customerPopinDto && selectedId === "intention-changer-de-mobile") {
                $('#customer-popin-id').modal('show')
            } else {
                if (selectedId === "intention-tseul") {
                    this.intentionParam = TSEUL_PARAM;
                } else if (selectedId === "intention-acquisition") {
                    this.intentionParam = ACQUISITION_PARAM;
                } else if (selectedId === "intention-changer-de-mobile") {
                    // On est sur sosh : on force l'intention renouvellement
                    this.intentionParam = RENOUVELLEMENT_PARAM;
                }
                this.updateUrlWithIntention()
                this.loadDeviceDetails()
                    .then(detailsBySeoId => {
                            this.deviceDetailsBySeoId = detailsBySeoId;
                        }
                    )
                    .catch(() => window.location.href = this.mobileDetails.infoViewUrl);
            }

            this.updateBreadCrumbWithIntention()
            this.updateDatalayerForIntention()
        },
        updateDatalayerForIntention() {
            if (tmsData) {
                tmsData.offre_prix_ttc = this.formattedDevicePrice()

                if ((this.shop === "SOSH" && this.intentionParam === RENOUVELLEMENT_PARAM) || this.intentionParam === TSEUL_PARAM) {
                    tmsData.contexte_produit = "acquisition_terminal_seul"
                } else if (this.intentionParam === ACQUISITION_PARAM) {
                    if (this.selectedOffer?.offerSeoId) {
                        tmsData.contexte_produit = "acquisition_forfait_vers_terminal"
                    } else {
                        tmsData.contexte_produit = "acquisition_terminal_vers_forfait"
                    }
                } else if (this.intentionParam === PCM_PARAM) {
                    tmsData.contexte_produit = "changement_pcm"
                } else if (this.intentionParam === RENOUVELLEMENT_PARAM) {
                    tmsData.contexte_produit = "changement_renouvellement"
                }

                if (this.hasMobileBonusRecovery) {
                    tmsData.bonus_reprise = "true"
                } else {
                    tmsData.bonus_reprise = "false"
                }

                Tms.view(tmsData)
            }
        },
        updateUrlWithIntention() {
            if (this.intentionParam === RENOUVELLEMENT_PARAM || this.intentionParam === CHANGER_DE_MOBILE_PARAM){
                return window.history.replaceState({}, null, updateUrlWithParam(window.location.href, "intention", CHANGER_DE_MOBILE_PARAM))
            }
            else return window.history.replaceState({}, null, updateUrlWithParam(window.location.href, "intention", this.intentionParam))
        },
        getMoreDeviceReviews: function () {
            if (this.displayRatings) {
                this.deviceDetailsReviews.offset += this.deviceDetailsReviews.blocSize;
                this.fetchDeviceReviews().then(result => {
                    this.deviceDetailsReviews.reviews = this.deviceDetailsReviews.reviews.concat(result.reviews);
                });
            }
        },
        updateDeviceDetailsReviews: function () {
            if (this.displayRatings) {
                this.deviceDetailsReviews.loading = true;
                this.fetchDeviceReviews().then(result => {
                    this.deviceDetailsReviews.totalNumber = result.totalNumber;
                    this.deviceDetailsReviews.blocSize = result.blocSize;
                    this.deviceDetailsReviews.reviews = result.reviews;
                    this.deviceDetailsReviews.loading = false;
                });
            }
        },
        loadDeviceReviews: function () {
            if (this.displayRatings) {
                this.selectedRatingsFilter = [];
                this.deviceDetailsReviews.loading = true;
                this.deviceFilterReviews.loading = true;
                this.deviceAverageRatingReviews.loading = true;
                this.fetchDeviceReviews().then(result => {
                    this.deviceDetailsReviews.totalNumber = result.totalNumber;
                    this.deviceDetailsReviews.blocSize = result.blocSize;
                    this.deviceDetailsReviews.reviews = result.reviews;
                    this.deviceAverageRatingReviews.averageRatings = result.averageRatings;
                    this.deviceFilterReviews.ratingsFilter = result.ratingsFilter;
                    this.deviceDetailsReviews.loading = false;
                    this.deviceFilterReviews.loading = false;
                    this.deviceAverageRatingReviews.loading = false;
                });
            }
        },
        loadMobilesViewsHistory() {
            return new Promise((resolve) => {
                //Historique de navigation on appelle l'api que si le browserId est présent, clé activée et aussi l'univers différent de DATA
                //Le browserId est récupéré depuis le cookie o_idzone CLIENT_ID c'est une valeur unique par navigateur
                //Pour un client connecté le clientId est récupéré depuis le cookie o_idzone USER_EXTERNAL_ID_HASH c'est une valeur unique par client
                let browserId = window.o_idzone ? window.o_idzone.CLIENT_ID : null;
                let clientId = window.o_idzone ? window.o_idzone.USER_EXTERNAL_ID_HASH : null;
                let offer = this.selectedOffer ? this.selectedOffer.offerSeoId : null
                if (browserId && this.showNavigationHistory) {
                    fetchMobilesViewsHistory(this.shop, offer, this.universe, browserId, clientId, this.intentionParam).then(result => {
                        this.mobilesViewsHistory = result;
                        resolve(result)
                    }).catch((error) => {
                        if (window.MyShop && window.MyShop.crashLogReporter) {
                            let reporter = window.MyShop.crashLogReporter;
                            reporter.logError(error);
                        }
                        resolve(null)
                    });
                }
            });
        },
        fetchDeviceReviews: function () {
            let url = "/api/mobile/device-reviews";
            return new Promise((resolve) => {
                $.ajax({
                    method: "GET",
                    data: {
                        "shop": this.shop,
                        "universe": this.universe,
                        "intention": this.intentionParam,
                        "eans": this.allVersions.map(it => it.ean.value),
                        "offset": this.deviceDetailsReviews.offset,
                        "ratings-input-filter": this.selectedRatingsFilter.toString(),
                    },
                    xhrFields: {
                        withCredentials: true
                    },
                    traditional: true, // pour éviter que jquery rename le paramètre eans -> eans[]
                    crossDomain: true,
                    url: url,
                    contentType: "application/json",
                    dataType: "json"
                }).done(result => {
                    resolve(result)
                }).fail((error) => {
                    resolve(error.responseJSON)
                });
            });
        },
        getAction() {
            switch (this.currentVersion.grade.label) {
                case "good":
                    return "voir_etat_correct";
                case "very_good":
                    return "voir_tres_bon_etat";
                case "perfect":
                    return "voir_parfait_etat";
                case "excellent":
                    return "voir_excellent_etat";
            }
        },
        isPriceInversionEnabledForDevice: function (price) {
            return this.isPriceInversionEnabled && !!price?.monthlyPayment?.monthlyAmountInCents;
        },
        updateRatingsFilterHandler(selectedRatingsFilter) {
            this.selectedRatingsFilter = selectedRatingsFilter;
            this.deviceDetailsReviews.offset = 0;
            this.updateDeviceDetailsReviews()
        },
        updateLayout() {
            let elem = $('#slide-filters-reviews-modal');
            if (elem.hasClass('show')) {
                if (window.matchMedia("(min-width: " + myshop.ob1.breakpoints.md + "px)").matches) {
                    elem.modal('hide');
                }
            }
            this.updateEsimOnlyTooltipPosition();
        },
        updateEsimOnlyTooltipPosition() {
            if (window.matchMedia("(min-width: " + myshop.ob1.breakpoints.md + "px)").matches) {
                this.esimOnlyTooltipPosition = 'ob1-tooltip-left';
            } else {
                this.esimOnlyTooltipPosition = 'ob1-tooltip-top';
            }
        },
        updateRecoveryPrice(priceInCents, model) {
            this.estimatedDevice.recoveryPriceInCents = priceInCents;
            this.estimatedDevice.model = model;
            $("#" + this.simulatorModalId).modal('hide');
            $("#" + this.currentSimulationResultModalId).modal('show');
        },
        newSimulation() {
            $("#" + this.savedSimulationResultModalId).modal('hide');
            $("#" + this.currentSimulationResultModalId).modal('hide');
            $("#" + this.simulatorModalId).modal('show');
        },
        saveSimulation() {
            this.loadDeviceDetails()
                .then(detailsBySeoId => {
                    this.deviceDetailsBySeoId = detailsBySeoId;
                })
                .catch(() => window.location.href = this.mobileDetails.infoViewUrl);
        }
    },
}
</script>
